const IGNORED_KEY_PREFIX = '_';

function coerceToString(value: unknown): string | null {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed ? trimmed : null;
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(value);
  }

  return null;
}

function findValueByPatterns(
  metadata: Record<string, unknown> | null | undefined,
  patterns: RegExp[],
): string | null {
  if (!metadata) return null;

  const entries = Object.entries(metadata).filter(([key]) => !key.startsWith(IGNORED_KEY_PREFIX));

  for (const pattern of patterns) {
    for (const [key, value] of entries) {
      if (!pattern.test(key)) continue;
      const result = coerceToString(value);
      if (result) return result;
    }
  }

  return null;
}

export function getNomeFromMetadata(
  metadata: Record<string, unknown> | null | undefined,
): string | null {
  return findValueByPatterns(metadata, [
    /^nome$/i,
    /^nome[_-]?completo$/i,
    /^nome[_-]?(inquilino|cliente|contraparte|devedor|pagador|titular|responsavel)$/i,
    /nome/i,
  ]);
}

export function getCpfCnpjFromMetadata(
  metadata: Record<string, unknown> | null | undefined,
): string | null {
  return findValueByPatterns(metadata, [
    /^cpf[_-]?cnpj$/i,
    /^cpf$/i,
    /^cnpj$/i,
    /^documento$/i,
    /cpf[_-]?cnpj/i,
    /(^|[_-])(cpf|cnpj|documento)([_-]|$)/i,
    /(cpf|cnpj)/i,
  ]);
}

export function getWhatsappFromMetadata(
  metadata: Record<string, unknown> | null | undefined,
): string | null {
  return findValueByPatterns(metadata, [
    /^whatsapp$/i,
    /^telefone$/i,
    /^celular$/i,
    /^contato$/i,
    /whatsapp/i,
    /telefone[_-]?(contato|whatsapp|celular|inquilino|cliente|contraparte)/i,
    /(celular|whatsapp)/i,
    /telefone/i,
  ]);
}

export function getEmailFromMetadata(
  metadata: Record<string, unknown> | null | undefined,
): string | null {
  return findValueByPatterns(metadata, [
    /^e[_-]?mail$/i,
    /^email$/i,
    /email[_-]?(inquilino|cliente|contraparte|contato)/i,
    /e?mail/i,
  ]);
}
